import SocialCard from '../components/SocialCard';
import ContactForm from '../components/ContactForm';

function Contact() {
  return (
    <main>
      <section className='contact-page-wrapper container-large'>
        <div className='contact-panel'>
          <div className='contact-panel__header'>
            <p className='contact-panel__eyebrow'>Get in touch</p>
            <h1>Contact</h1>
            <p className='contact-panel__intro'>
              Reach out for speaking, writing, media, or general inquiries.
              The form below opens your email app with a drafted message so you
              can send it directly.
            </p>
          </div>
          <div className='contact-panel__grid'>
            <aside className='contact-panel__sidebar'>
              <div className='contact-panel__info-card'>
                <p className='contact-panel__meta-label'>Email</p>
                <a
                  className='contact-panel__email'
                  href='mailto:skysprowles@yahoo.com'
                >
                  skysprowles@yahoo.com
                </a>
                <p className='contact-panel__meta-copy'>
                  Best for interviews, event requests, or questions about the
                  work.
                </p>
              </div>
              <SocialCard />
            </aside>
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
